import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Headers, Response } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable"
import "rxjs/add/operator/map";

@Injectable()
export class BonusCalculationApiService {

  constructor(
    private http: Http,
    private authHttp: AuthHttp
  ) { }

  GetBonusCalculations(){
    return this.authHttp.get(environment.apiEndPoint + '/bonuscalculation/calculations').map( (response : Response) => response.json());
  }

  GetBonusCalculationsByYear(year){
    return this.authHttp.get(environment.apiEndPoint + '/bonuscalculation/calculations/' + year).map((response: Response) => response.json());
  }

  GetBonusCalculation(ID) {
    return this.authHttp.get(environment.apiEndPoint + '/bonuscalculation/' + ID).map((response: Response) => response.json());
  }

  GetExcelData(ID) {
    return this.authHttp.get(environment.apiEndPoint + '/bonuscalculation/excel/' + ID).map((response: Response) => response.json());
  }

  SaveExcelData(data) {
    var formData = new FormData();
    formData.append("workbookJSON", JSON.stringify(data.workbookJSON));
    formData.append("mode", data.mode);
    
    return this.authHttp.post(environment.apiEndPoint + '/bonuscalculation/excel/' + data.ID, formData).map((response: Response) => response.json());
  }

  ExtractData(ID){
    var formData = new FormData();
    formData.append("ID", ID);
    return this.authHttp.post(environment.apiEndPoint + '/bonuscalculation/extractData', formData).map((response : Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/BonusCalculationApi.service.ts